/* eslint-disable no-console */
import M from 'materialize-css/dist/js/materialize';
import * as actionLinePicking from '../actions/linePickingAction';
import { endLoading, startLoading } from '../actions/loadingAction';
import PickingService from '../services/PickingService';
import { ENUMS, PERMISSIONS, VISIONS } from '../utils/constants';
import { getUrlExpeditionApi, isNullOrEmpty, language, objPagination, parseParams, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';
import { checkPermission, getUser, getVision } from './auth';

const httpService = new HttpService(getUrlExpeditionApi(window));

export default class LinePickingService {
    static firstOrder(filter, callback) {
        filter.excludeOrderGrouped = false;
        filter.status = [];
        const url = '/api/linepicking/orders/first';

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200) {
                        if (response.data.data && response.data.data.orders) {
                            const dadosFilter = response.data.data;
                            if (dadosFilter?.orders?.length > 0) {
                                const dados = [dadosFilter]
                                const ordersPage = objPagination(dados[0].orders);
                                const orderSelect = dados[0].orders.filter((m) => (m.status === ENUMS.eOrderStatus.Waiting.value || m.status === ENUMS.eOrderStatus.InProgress.value)
                                    && m.items?.filter((j) => j.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length <= 0);

                                dispatch(actionLinePicking.resetOrder());
                                dispatch(actionLinePicking.resetOrders());
                                dispatch(actionLinePicking.resetOrderGroup());
                                dispatch(actionLinePicking.selectOrderGroup(dados[0]));
                                dispatch(actionLinePicking.setOrders(ordersPage));
                                dispatch(actionLinePicking.selectOrder(orderSelect[0]));
                                if (callback) {
                                    callback(orderSelect[0]);
                                }
                            }
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static startOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}/start`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLinePicking.updateOrderStatus(orderId, ENUMS.eOrderStatus.InProgress.value));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static startOrderItem(orderId, orderItemId, callback) {
        const url = '/api/picking/mission/start';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, orderItemId }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLinePicking.updateMissionStatus(orderItemId, ENUMS.eOrderItemStatus.InProgress.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    console.log('error on start orderItem', error);
                    if (callback) callback();
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static confirmPicking(orderItem, callback) {
        const url = '/api/picking';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, {
                    orderId: orderItem.orderId,
                    orderItemId: orderItem.orderItemId,
                    confirmMasterCim: orderItem.confirmMasterCim
                }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLinePicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingFinish.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                showMessageToastCustom(translate('warning', 'general'), "Sem Conexão", 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        };
    }

    static getOrders(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/picking/orders';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(actionLinePicking.setOrders(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getOrdersReport(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/picking/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static rePicking(orderItem, areas, callback) {
        const url = '/api/picking/repicking';
        const dataSend = {
            orderId: orderItem.orderId,
            orderItemId: orderItem.orderItemId,
            justificationId: orderItem.justificationId,
            areas
        }

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, dataSend).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLinePicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingRepicking.value));
                        const newOrder = response.data?.newOrder;
                        if (newOrder && newOrder.orderId !== 0) {
                            dispatch(actionLinePicking.addOrder(newOrder));
                        }
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static unblockOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}/unblock`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLinePicking.unblockOrder(orderId));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static userHasGroup(user) {
        const url = `/api/linepicking/userhasgroup?user=${user}`;
        if (navigator.onLine) {
            httpService.instance.get(url).then((response) => {
                if (response.status === 200) {
                    return response.data.data;
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            });
        }
    }

    static abandonTask(orderId, callback) {
        const url = `/api/linepicking/orders/abandontask/${orderId}`;
        if (navigator.onLine) {
            httpService.instance.put(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback()
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            });
        }
    }

    static updateOrderFromServer(order, changeUser) {
        return (dispatch) => {
            try {
                if (order) {
                    const manageOrder = checkPermission(PERMISSIONS.Expedition.Picking.ManageOrder);
                    const currentUser = getUser();
                    if ((!manageOrder && order.startedBy !== currentUser.userName)
                        || (order.status === ENUMS.eOrderStatus.Finished.value
                            || order.status === ENUMS.eOrderStatus.Canceled.value
                            || order.status === ENUMS.eOrderStatus.ManuallyFinished.value)) {
                        // dispatch(actionLinePicking.removeOrder(order.orderId, true));
                    } else {
                        if (order.startedBy && order.startedBy.includes(currentUser.userName) && changeUser) {
                            if (VISIONS.Fiasa === getVision()) {
                                dispatch(actionLinePicking.updateOrder(order));
                                dispatch(actionLinePicking.selectOrder(order));
                                dispatch(PickingService.getMissions(order.orderId));
                                const url = `/api/linepicking/userhasgroup?user=${currentUser.userName}`;
                                if (navigator.onLine) {
                                    httpService.instance.get(url).then((response) => {
                                        if (response.status === 200) {
                                            dispatch(actionLinePicking.setOrderReceived({
                                                order: order,
                                                showModalReceivedOrder: true,
                                                noHasGroup: response.data.data <= 0 ? true : false
                                            }));
                                        }
                                    }).catch((error) => {
                                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                                    });
                                }
                            } else {
                                showMessageToastCustom(translate('warning', 'general'), "Atenção! Nova tarefa atribuída a você.", 18000, 'mdi mdi-message-bulleted blue-text');
                            }
                        }
                    }
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static postponeOrderReceived(order, callback) {
        const url = `/api/linepicking/orders/postpone/${order.orderId}`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static leave(orderGroupId, abandon, callback) {
        const url = `/api/linepicking/ordergroup/leave`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderGroupId: orderGroupId, leave: abandon }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    static changeUserOrder(orderId, newUser, changeGroup, callback) {
        const url = '/api/linepicking/orders/changeuser';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, newUser, changeGroup }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLinePicking.changeUserOrder(orderId, newUser));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static changeRouteOrder(orderId, routeId, callback) {
        const url = '/api/linepicking/orders/changeroute';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, routeId }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static cancelOrderFromServer(order) {
        return (dispatch) => {
            try {
                if (order) {
                    dispatch(actionLinePicking.removeOrder(order));
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static addOrderFromServer(order) {
        return (dispatch) => {
            try {
                if (order) {
                    dispatch(actionLinePicking.addOrder(order));
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static getNextOrder(filter, callback) {
        const url = '/api/linepicking/orders/next';
        filter.nextOrder = true;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200 && response?.data?.data) {
                        let dados = response.data.data;
                        dispatch(actionLinePicking.addOrder(dados));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message || 'Nenhum pedido encontrado!', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback(response);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback(error.response || error);
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static addQrCode(qrcode, callback) {
        const url = '/api/qrcode/';
        qrcode.qrCodeTypeId = parseInt(qrcode.qrCodeTypeId);
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, qrcode).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateQrCode(qrcode, callback) {
        const url = '/api/qrcode/';
        qrcode.qrCodeTypeId = parseInt(qrcode.qrCodeTypeId);
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, qrcode).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static finishOrderGroup(filter, callback) {
        const url = '/api/linepicking/orderGroup/finish';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderGroupId: filter.orderGroupId, finalQrCode: filter.finalQrCode }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getQrCodes(filter, callback) {
        const url = '/api/qrcode/';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionLinePicking.setQrCodes(response.data.data));
                        if (callback) {
                            callback(response);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteQrCode(id, callback) {
        const url = '/api/qrcode/' + id;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getQrCodeType(callback) {
        const url = '/api/qrcode/qrcodetype/';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionLinePicking.setQrCodeType(response.data.data));
                        if (callback) {
                            callback(response);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static unblock(orderId, changeGroup, callback) {
        const url = '/api/linepicking/orders/unblock';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, changeGroup }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getOrderGroupUser(callback) {
        const url = '/api/linepicking/ordergroup';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback && response.data?.data) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static materialNotFound(orderItem, callback) {
        const url = '/api/linepicking/materialnotfound';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url,
                    {
                        partial: orderItem.partial,
                        orderId: orderItem.orderId,
                        orderItemId: orderItem.orderItemId,
                        justificationId: orderItem.justificationId,
                        routeId: orderItem.routeId
                    }).then((response) => {
                        if (response.status === 200) {
                            dispatch(actionLinePicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.NotFound.value));
                            dispatch(actionLinePicking.updateOrderStatus(orderItem.orderId, ENUMS.eOrderStatus.NotFound.value));
                            if (callback) {
                                callback();
                            }
                        } else {
                            M.toast({ html: response.data.message, classes: 'red' });
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static finishedmaterialNotFound(orderId, callback) {
        const url = `/api/linepicking/finishedmaterialnt/${orderId}`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLinePicking.updateOrderStatus(orderId, ENUMS.eOrderStatus.NotFoundFinished.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getTransmission(filter, report, callback) {
        const url = '/api/transmission';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (!report) {
                            dispatch(actionLinePicking.setTransmissionsList(response.data?.data));
                        }
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static forceTramission() {
        const url = '/api/transmission';
        return (dispatch) => {
            if (navigator.onLine) {
                //dispatch(startLoading());
                httpService.instance.patch(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status !== 200) {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), "Em processamento...", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getKanban(callback) {
        const url = `/api/linepicking/kanban`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getReport(filter, callback) {
        const url = '/api/picking/orders/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static connectMq(callback) {
        const url = `/api/linepicking/connectmq`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        showMessageToastCustom(translate('general.info'), response.data?.data, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static disconnectMq(callback) {
        const url = `/api/linepicking/disconnectmq`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        showMessageToastCustom(translate('general.info'), response.data?.data, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static uploadFile(file, callback) {
        const url = '/api/linepicking/uploadfile';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('file', file);
                httpService.instance.post(url, formData).then((response) => {
                    if (isNullOrEmpty(response.data.data)) {
                        showMessageToastCustom(translate('confirmed', 'general'), "Arquivo processado com sucesso.", 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        let result = [];
                        var keys = Object.keys(response.data.data);
                        keys.map((key) => result.push({ code: key, message: response.data.data[key] }))
                        if (callback) {
                            callback(result);
                        }
                    }

                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getFileLog(filter, pagination, callback) {
        Object.assign(filter, pagination);
        if (navigator.onLine) {
            let msg = '';
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/filelog`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    msg = response.data;
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    if (msg !== '') {
                        showMessageToastCustom(translate('warning', 'general'), msg, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    else {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static getReportFileLog(filter, callback) {
        const url = '/api/filelog/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getQueues(filter, callback) {
        const url = '/api/linepicking/queuelist';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getRoutes(filter, callback) {
        const url = '/api/linepicking/routelist';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    //#region Mapping

    static getMappingPaged(filter, bind, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/mapping/paged`, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (bind) {
                            dispatch(actionLinePicking.setMappings(response.data.data));
                        }

                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getMapping(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/mapping`, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                }).then((response) => {
                    dispatch(endLoading());
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                });
            };
        }
    }

    static getLastReceipt(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                // dispatch(startLoading());
                httpService.instance.get(`/api/mapping/receiptStorage`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                })
                // .finally(() => {
                //     dispatch(endLoading());
                // });
            };
        }
    }

    static getLastMapping(callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/mapping/last`, null, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deleteMapping(id, callback) {
        if (navigator.onLine) {
            const url = `/api/mapping/${id}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static createMapping(postObj, callback) {
        const url = '/api/mapping';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                if (postObj.fileMdrNew) {
                    formData.append('FileMdr', postObj.fileMdrNew);
                }

                if (postObj.filePartNumberNew) {
                    formData.append('FilePartNumber', postObj.filePartNumberNew);
                }

                formData.append('Mapping', JSON.stringify(postObj));
                httpService.instance.post(url, formData).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateMapping(putObj, callback) {
        const url = '/api/mapping';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                if (putObj.fileMdrNew) {
                    formData.append('FileMdr', putObj.fileMdrNew);
                }

                if (putObj.filePartNumberNew) {
                    formData.append('FilePartNumber', putObj.filePartNumberNew);
                }

                formData.append('Mapping', JSON.stringify(putObj));
                httpService.instance.put(url, formData).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static uploadMapping(file, callback) {
        const url = '/api/mapping/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static deleteSelectedMappings(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/mapping/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static sendLabelFileMapping(selectedIds, printer, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                let url = `/api/mapping/label`;
                httpService.instance.post(url, { printer, ids: selectedIds }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (!isNullOrEmpty(response.data.data) && response.data.data.length > 0) {
                            let arrayLabel = [];
                            response.data.data.forEach(element => {
                                if (!isNullOrEmpty(element)) {
                                    arrayLabel.push({ dataToPrint: element });
                                }
                            });
                            console.log(arrayLabel);
                            if (arrayLabel.length > 0) {
                                this.printLabel(arrayLabel, printer);
                            }
                        }
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static downloadFileMapping(ids, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                let url = `/api/mapping/report`;
                httpService.instance.post(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static addPartNumberPdu(filter, callback) {
        const url = '/api/partnumberpdu';

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200) {
                        showMessageToastCustom(translate('confirmed', 'general'), translate('sucess-to-include', 'general'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback(response);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static searchQRCodeCalls(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/partnumberpdu/search';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const data = response.data.data;
                        if (callback) {
                            callback(data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteQrCodeCall(id, callback) {
        const url = '/api/partnumberpdu/' + id;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static uploadPartnumberPdu(file, callback) {
        const url = '/api/partnumberpdu/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static getPartNumberDescription(code, callback) {
        const url = 'api/partnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: { code } }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    callback();
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static updateQuantityAlignment(putObj, callback) {
        const url = '/api/mapping/quantityalignment';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, putObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static uploadQuantityAlignment(file, callback) {
        const url = '/api/mapping/quantityalignment/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    //#endregion Mapping

    static printLabel(labels, print) {
        if (print.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
            if (navigator.userAgent === 'logisticspwa' && labels.length > 0) {
                const sendToPrinter = {
                    messageType: 'printArray',
                    printerManufacturer: print.printerManufacture || ENUMS.ePrinterManufacturerPortable.Honeywell.value,
                    array: labels,
                    printerAddress: print.macAddress,
                    lng: language()
                };

                window.ReactNativeWebView.postMessage(JSON.stringify(sendToPrinter));
            } else {
                showMessageToastCustom(translate('warning', 'general'), 'Impressão não pode ser realizada', 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        }
    }

    static getMappingRegistrationPaged(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/mappingregistration`, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionLinePicking.setMappingsRegistrations(response.data.data));
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }


    static getMappingRegistrationAll(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                httpService.instance.get(`/api/mappingregistration/all`, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionLinePicking.setMappingsRegistrations(response.data.data));
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            };
        }
    }

    static createMappingRegistration(postObj, callback) {
        const url = '/api/mappingregistration';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, postObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static updateMappingRegistration(putObj, callback) {
        const url = '/api/mappingregistration';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());

                httpService.instance.put(url, putObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static uploadMappingRegistration(file, mappingRegistrationTypeId, callback) {
        const url = '/api/mappingregistration/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);
                formData.append('MappingRegistrationTypeId', mappingRegistrationTypeId);
                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());
                    if (callback) {
                        callback(response.data?.data?.result);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static deleteMappingRegistration(id, callback) {
        if (navigator.onLine) {
            const url = `/api/mappingregistration/${id}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }
    static deleteSelectedMappingsRegistration(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/mappingregistration/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getPartnumbersUseModelPaged(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/partnumberusemodel/paged`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionLinePicking.setPartnumbersUseModel(response.data.data));
                    }
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getPartnumbersUseModelAll(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                httpService.instance.get(`/api/partnumberusemodel/all`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionLinePicking.setPartnumbersUseModel(response.data.data));
                    }
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            };
        }
    }

    static addPartnumberUseModel(addDto, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/partnumberusemodel`, addDto, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data) {
                        if (callback) {
                            callback(response.data?.success);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static uploadPartnumbersUseModel(file, callback) {
        const url = '/api/partnumberusemodel/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static editPartnumberUseModel(editDto, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(`/api/partnumberusemodel`, editDto, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data) {
                        if (callback) {
                            callback(response.data?.success);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deletePartnumberUseModel(id, callback) {
        const url = '/api/partnumberusemodel/' + id;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteSelectedPartNumberUseModel(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/partnumberusemodel/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), "Excluido com sucesso", 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static insertRequestOutSide(data, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/requestByMapping`, data, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data && callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getPagedOutSide(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/requestbymapping/paged`,
                    { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200 && response.data?.data) {
                            dispatch(actionLinePicking.setPartOutsides(response.data.data));
                        }
                        if (callback) {
                            callback();
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }

    static getOutSide(partNumber, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/requestByMapping/outside/partNumber?partNumber=${partNumber}`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    dispatch(endLoading());
                    if (response.status === 200 && response.data?.data && callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                });
            };
        }
    }

    static getPartnumbersOutSide(partNumber, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/requestByMapping/partNumber?partNumber=${partNumber}`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data && callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static finishRequestOutSide(data, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(`/api/requestByMapping/finalize`, data, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback();
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deleteRequestOutSide(data, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(`/api/requestByMapping/${data.id}`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback();
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }
    static setArea(area) {
        return (dispatch) => { dispatch(actionLinePicking.setArea(area)); };
    }

    static setSectors(sectors) {
        return (dispatch) => { dispatch(actionLinePicking.setSectors(sectors)); };
    }


}